import { render, staticRenderFns } from "./OverdueDebtorList.vue?vue&type=template&id=1db4a842&scoped=true&"
import script from "./OverdueDebtorList.vue?vue&type=script&lang=js&"
export * from "./OverdueDebtorList.vue?vue&type=script&lang=js&"
import style0 from "./OverdueDebtorList.vue?vue&type=style&index=0&id=1db4a842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db4a842",
  null
  
)

export default component.exports